// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateAgentMarketingProfileFeaturedPhoto(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfileFeaturedPhotoUpdated"]);
}

var variablesConverter = {"updateAgentMarketingProfileFeaturedPhotoInput":{"featuredPhoto":{"r":"imageInput"}},"imageInput":{},"__root":{"input":{"r":"updateAgentMarketingProfileFeaturedPhotoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateAgentMarketingProfileFeaturedPhoto_AgentMarketingProfileFeaturedPhotoUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileFeaturedPhoto":{"u":"response_updateAgentMarketingProfileFeaturedPhoto"}}};

var wrapResponseConverterMap = {
  response_updateAgentMarketingProfileFeaturedPhoto: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateAgentMarketingProfileFeaturedPhoto_AgentMarketingProfileFeaturedPhotoUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileFeaturedPhoto":{"u":"response_updateAgentMarketingProfileFeaturedPhoto"}}};

var responseConverterMap = {
  response_updateAgentMarketingProfileFeaturedPhoto: unwrap_response_updateAgentMarketingProfileFeaturedPhoto
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "PNG" || $$enum === "JPEG" || $$enum === "GIF" || $$enum === "WEBP") {
    return $$enum;
  }
  
}

function imageContentType_fromString(str) {
  return imageContentType_decode(str);
}

var Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileFeaturedPortraitForm_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileFeaturedPhoto",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileFeaturedPhotoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "AgentMarketingProfileFeaturedPortraitForm_UpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileFeaturedPhoto",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "featuredPhoto",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 400
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileFeaturedPhotoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccd3d2f26c073084505e08db256d8a57",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileFeaturedPortraitForm_UpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfileFeaturedPortraitForm_UpdateMutation(\n  $input: UpdateAgentMarketingProfileFeaturedPhotoInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateAgentMarketingProfileFeaturedPhoto(input: $input) {\n    __typename\n    ... on AgentMarketingProfileFeaturedPhotoUpdated {\n      marketingProfile {\n        ...AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileFeaturedPortraitForm_agentMarketingProfile on AgentMarketingProfile {\n  featuredPhoto {\n    url(width: 400, ratio: $__relay_internal__pv__DevicePixelRatio)\n    height\n    width\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var wrap_response_updateAgentMarketingProfileFeaturedPhoto = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentMarketingProfileFeaturedPhoto = unwrap_response_updateAgentMarketingProfileFeaturedPhoto;
exports.wrap_response_updateAgentMarketingProfileFeaturedPhoto = wrap_response_updateAgentMarketingProfileFeaturedPhoto;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
